module.exports = __webpack_public_path__ + "img/gc_country_flag_ee.996ed766.svg";